<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0 mx-0':'pr-0'">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'RequestsNavNode'"
      [childNavState]="'ADBFormNavNode'"></app-my-account-left-sidenav>
    </div>
  }
  @if (apiloaded) {
    <div [ngClass]="isMobile? 'col-12 px-0' :'col-12 col-sm-12 pr-0 my-account-right-nav'">
      <h1 class="myProfileTopHeader m-0">{{'common.text_application_requestt'|cxTranslate}}
      </h1>
      <div class="myProfileBody">
        <div class="mx-0 col-xs-12 col-sm-12 col-md-12 col-lg-9">
          <div class="search-admin-label-block">
            <label for="input" class="searchTerm">Search Term</label>
          </div>
          <div class="row  search-admin-block">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
              <input type="text" class="form-control admin-input-search w-100" placeholder="Enter"
                [(ngModel)]="query">
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 " [class.px-0]="!isMobile">
                <button class="btn btn-primary btn-admin-search" [ngClass]="isMobile? 'w-100 mt-2':''"
                  (click)="postCall()">
                  {{'common.text_training_request_table_search'|cxTranslate}}
                  <img src="/icons/link-white.svg" width="20px" alt="">
                </button>
              </div>
            </div>
          </div>
          @if ( BrakeRequests?.searchRetsults && BrakeRequests?.searchRetsults.length==0) {
            <div class="py-5">
              <b>{{'common.text_account_supporttickets_noSupporttickets'|cxTranslate}}</b>
            </div>
          }
        </div>
        @if ( BrakeRequests?.searchRetsults && BrakeRequests?.searchRetsults.length>0) {
          <div>
            <div class="gray-search-result-box">
              {{BrakeRequests?.pagination?.totalResults}}{{'common.text_company_manageUser_registration_totalResults'|cxTranslate|slice:3}}
            </div>
            <div [class.sort-section]="isMobile" class="account-overview-table mycompany-manageUser">
              <table class="responsive-table table table-bordered table-blue break-admin-search-table">
                <thead>
                  <tr class="responsive-table-head hidden-xs hidden-sm">
                    <th scope="col">
                      <a (click)="sort('byCreationDate')">
                        <span><u>{{'common.text_generalInfo_submitdate'|cxTranslate}}</u>
                        @if (sortByDateCreated === ascending) {
                          &#8593;
                        }
                        @if (sortByDateCreated === descending) {
                          &#8595;
                        }
                      </span>
                    </a>
                  </th>
                  <th scope="col">
                    <a>
                      <span>{{'common.text_core_search_appNumber'|cxTranslate}}
                      </span>
                    </a>
                  </th>
                  <th scope="col">
                    <a>
                      <span>{{'common.text_generalInfo_customerid'|cxTranslate}}
                      </span>
                    </a>
                  </th>
                  <th scope="col">
                    <a (click)="sort('byStatus')">
                      <span><u>{{'common.text_headline_status'|cxTranslate}}</u>
                      @if (sortByStatus === ascending) {
                        &#8593;
                      }
                      @if (sortByStatus === descending) {
                        &#8595;
                      }
                    </span>
                  </a>
                </th>
                <th scope="col">
                  <a>
                    <span>{{'common.text_generalInfo_comments'|cxTranslate}}
                    </span>
                  </a>
                </th>
                <th scope="col">
                  <a>
                    <span>{{'common.text_account_supporttickets_createTicket_attachement_label'|cxTranslate}}
                    </span>
                  </a>
                </th>
              </tr>
            </thead>
            @if (BrakeRequests?.searchRetsults) {
              <tbody>
                @for (item of BrakeRequests?.searchRetsults; track item) {
                  <tr class="responsive-table-item">
                    <td class="responsive-table-cell">
                      <span class="d-lg-none">{{'common.text_generalInfo_submitdate'|cxTranslate}}</span>
                      <span>{{item?.submitDate | date:'dd/MM/yyyy hh:mm'}}</span>
                    </td>
                    <td class="responsive-table-cell">
                      <span class="d-lg-none">{{'common.text_core_search_appNumber'|cxTranslate}}</span>
                      <a (click)="editUser(item.code)">
                        <span class="mycompnay-registration-value pointer">{{item.code}}</span>
                      </a>
                    </td>
                    <td class="responsive-table-cell">
                      <span class="d-lg-none">{{'common.text_generalInfo_customerid'|cxTranslate}}</span>
                      <span class="mycompnay-registration-value pointer">
                        {{item?.companyName}}
                      </span>
                    </td>
                    <td class="responsive-table-cell">
                      <span class="mycompnay-registration-value pointer">
                        @if (item?.status == 'INREVIEW') {
                          {{'common.adb_approvalType_INREVIEW'|cxTranslate}}
                        }
                        @if (item?.status == 'RECEIVED') {
                          {{'common.adb_approvalType_RECEIVED'|cxTranslate}}
                        }
                        @if (item?.status == 'AWAITING') {
                          {{'common.adb_approvalType_AWAITING'|cxTranslate}}
                        }
                        @if (item?.status == 'REJECTED') {
                          {{'common.adb_approvalType_REJECTED'|cxTranslate}}
                        }
                        @if (item?.status == 'SAVED') {
                          {{'common.adb_approvalType_SAVED'|cxTranslate}}
                        }
                      </span>
                    </td>
                    <td class="responsive-table-cell view-center">
                      @if (item?.customerAndAdmincomments && item?.customerAndAdmincomments.length > 0) {
                        <a
                          (click)="openComments(item?.customerAndAdmincomments)">
                          {{'common.break_view_comments'|cxTranslate}}
                        </a>
                      }
                    </td>
                    <td class="responsive-table-cell view-center">
                      <span class="mycompnay-registration-value">
                        <span><a
                        (click)="downloadZip(item?.zipFileAttachment?.fileCode,item?.code)">{{item?.zipFileAttachment?.altText}}</a></span>
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
        <div class="exportDownloadButton">
          <div class="fs_20 export-download-text">{{'common.click_export_download'|cxTranslate}}</div>
          <div class="fs_24 export-download-btn-block"><button (click)="exportDataToExcel()"
            class="btn btn-primary">{{'common.text_account_openPositions_export'|cxTranslate}}<img
          src="/icons/link-white.svg" width="20px" alt=""></button></div>
        </div>
        @if (BrakeRequests?.searchRetsults) {
          <div class="account-orderhistory-pagination warranty-pagination">
            <div class="product__list--wrapper">
              <div class="pagination-bar">
                <div class="pagination-toolbar">
                  <div class="row sort-refine-bar">
                    <div class="col-xs-12 col-sm-12 col-md-6 bottom-result">
                      <div class="pagination-result">
                        {{'common.search_page_showing_text'|cxTranslate}}
                        {{(BrakeRequests.pagination.pageSize *
                        BrakeRequests.pagination.currentPage)+1 }} -
                        @if (BrakeRequests.pagination.pageSize > BrakeRequests.pagination.totalResults) {
                          <span
                            >
                          {{BrakeRequests.pagination.totalResults}} </span>
                        }
                        @if ((BrakeRequests.pagination.pageSize *(BrakeRequests.pagination.currentPage+1) < BrakeRequests.pagination.totalResults)&&(BrakeRequests.pagination.pageSize < BrakeRequests.pagination.totalResults)) {
                          <span
                            >
                            {{BrakeRequests.pagination.pageSize*(BrakeRequests.pagination.currentPage+1)}}
                            {{'common.search_page_of_text'|cxTranslate}}
                          {{BrakeRequests.pagination.totalResults}} </span>
                        }
                        @if ((BrakeRequests.pagination.pageSize *(BrakeRequests.pagination.currentPage+1) > BrakeRequests.pagination.totalResults)&&(BrakeRequests.pagination.pageSize < BrakeRequests.pagination.totalResults)) {
                          <span
                            >{{BrakeRequests.pagination.totalResults}}
                          of {{BrakeRequests.pagination.totalResults}} </span>
                        }
                        {{'common.search_page_result_text'|cxTranslate}}
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 kb-pagination-right kb-pagination">
                      <kb-pagination [pagination]="BrakeRequests?.pagination" [defaultPage]="0"
                        (viewPageEvent)="changePageCustom($event)">
                      </kb-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
</div>